import * as React from 'react';
import Project from 'src/entities/Project';
import Investment from 'src/entities/Investment';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import Payment from 'src/entities/Payment';
import ResultPageCardComponent from 'src/modules/commons/result-page/ResultPageCard.Component';

export interface FormalizationPaymentComponentProps {
  project: Project;
  investment: Investment;
  payment: Payment;
}

const ProjectPaymentComponent: React.StatelessComponent<FormalizationPaymentComponentProps> = (
  props: FormalizationPaymentComponentProps
) => {

  const totalValue = NumberFormater
    .euros(((props.investment.fees * 0.01) * 1.21 + 1) * props.investment.actualPrice!);

  const feeValue = NumberFormater
    .euros((props.investment.fees * 0.01) * 1.21 * props.investment.actualPrice!);

  const totalToInvest = NumberFormater
    .euros(props.investment.actualPrice!);

  if (props.investment.isPaid) {
    return (
      <div className="col-sm-9">
        <div className="gap-40" />
        <ResultPageCardComponent
          title={'Gracias por seguir todos los pasos para formalizar ' + props.project.company.name}
          message={'Una vez tengamos todas las firmas y desembolsos, los abogados de la operación continuarán con la ' +
          'elevación a público de la operación y en un plazo de un mes posterior a la elevación os dejaremos a ' +
          'vuestra disposición la escritura en los documentos de la operación.'}
          success={true}
        />
      </div>
    );
  } else if (props.payment) {
    return (
      <div>
        <div className="gap-40"/>
        <h1 className="f-s-26" style={{color: '#88B04B', textAlign: 'center'}}>
          PAGO DE LA OPERACIÓN
        </h1>
        <p className="text-center">
          Ha llegado el momento de realizar el pago. A continuación encontrarás los datos bancarios
          de tu eWallet, y te agradeceremos que transfieras el importe comprometido tan pronto puedas.
        </p>
        <p className="text-center">
          Con el fin de completar el pago por transferencia bancaria, por favor utilice los siguientes datos:
        </p>
        <p className="text-center">
          <strong>Concepto transferencia (Importante): </strong>
          {props.payment.wireReference}
        </p>
        <p className="text-center">
          <strong>IBAN de la entidad beneficiaria: </strong>
          ES0501490101140303781003
        </p>
        <p className="text-center">
          <strong>BIC de la entidad beneficiaria: </strong>
          BNPAESMSXXX
        </p>
        <p className="text-center">
          <strong>País de la entidad beneficiaria: </strong>
          España
        </p>
        <p className="text-center">
          <strong>Nombre del beneficiario: </strong>
          MANGOPAY SA
        </p>
        <p className="text-center">
          <strong>Domicilio: </strong>
          59 Boulevard Royal
        </p>
        <p className="text-center">
          <strong>Código Postal: </strong>
          L-2449
        </p>
        <p className="text-center">
          <strong>Población: </strong>
          Luxemburgo
        </p>
        <p className="text-center">
          <strong>País: </strong>
          Luxemburgo
        </p>
        <p className="text-center">
          Nota: Recuerde guardar los datos para realizar la transferencia correctamente.
        </p>
        <p className="text-center">
          <strong>Importe total a transferir: {totalValue}</strong>
        </p>
        <p className="text-center">
          Importe a invertir: {totalToInvest}
        </p>
        <p className="text-center">
          Corretaje: {feeValue}
        </p>
        <div className="gap-50"/>
      </div>
    );
  } else {
    return null;
  }
};

export default ProjectPaymentComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-payment/ProjectPayment.component.tsx